import { ArticleSidebar } from '@atreus/data';
import { Box, Button, Stack, Text } from '@qcx/ui';

interface CoursesProps {
  relatedCourses: ArticleSidebar['relatedCourses'];
}

export const Courses = ({ relatedCourses }: CoursesProps) => (
  <Stack flow="column" gap="$3">
    <Stack css={{ alignItems: 'center', justifyContent: 'space-between' }}>
      <Text css={{ color: '$neutral600' }} variant="md">
        Cursos relacionados
      </Text>
      <Button
        as="a"
        css={{
          fontWeight: '$medium',
          color: '$secondary700',
          fontSize: '$md'
        }}
        href={relatedCourses?.seeMoreLink}
        variant="neutralLink"
      >
        Ver todos
      </Button>
    </Stack>
    {relatedCourses?.courses.map((course, idx) => (
      <Box
        key={`course_${idx}`}
        as="a"
        css={{ bg: '$neutral50 ', p: '$3', borderRadius: '$lg' }}
        href={course.link}
      >
        <Stack flow="column">
          <Text css={{ color: '$neutral900' }} variant="md" weight="bold">
            {course.title}
          </Text>
          <Text css={{ color: '$neutral900' }} variant="md">
            {course.initials}
          </Text>
        </Stack>
      </Box>
    ))}
  </Stack>
);
